module.exports = __webpack_public_path__ + "static/media/Technology.ae1cb994.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Industries/Technology.svg
// module id = 324
// module chunks = 0